import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const ShieldCancelIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-shield-cancel${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M8.18464 13.95C8.1233 13.9673 8.06197 13.984 7.99997 14C6.96211 13.7308 5.98896 13.2557 5.13833 12.603C4.28771 11.9503 3.57698 11.1332 3.04837 10.2004C2.51976 9.26751 2.18406 8.23793 2.06122 7.17279C1.93838 6.10764 2.03091 5.02868 2.3333 4C4.41032 4.09504 6.44275 3.37772 7.99997 2C9.55719 3.37772 11.5896 4.09504 13.6666 4C14.0643 5.35219 14.0976 6.78544 13.7633 8.15467"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6666 12.6667C10.6666 13.1971 10.8773 13.7058 11.2524 14.0809C11.6275 14.4559 12.1362 14.6667 12.6666 14.6667C13.1971 14.6667 13.7058 14.4559 14.0808 14.0809C14.4559 13.7058 14.6666 13.1971 14.6666 12.6667C14.6666 12.1362 14.4559 11.6275 14.0808 11.2524C13.7058 10.8774 13.1971 10.6667 12.6666 10.6667C12.1362 10.6667 11.6275 10.8774 11.2524 11.2524C10.8773 11.6275 10.6666 12.1362 10.6666 12.6667Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3334 14L14 11.3333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default ShieldCancelIcon;
